import {
  SET_ORDER_VALID,
  SET_HAS_FORM_CHANGED,
  SET_HAS_CONTENT_LOADED,
  SET_CURRENT_DIALOG,
  SET_LANGUAGE,
  SET_PROMPT_LOGIN,
  SET_PAGE_TITLE,
  GlobalType,
} from '../../types/GlobalTypes';

const initialState: GlobalType = {
  orderValid: false,
  hasFormChanged: false,
  hasContentLoaded: false,
  currentDialog: undefined,
  language: 'no',
  promptForLogin: false,
  pageTitle: '',
};

export default function globalReducer(state: GlobalType = initialState, action: any): GlobalType {
  switch (action.type) {
    case SET_ORDER_VALID:
      return {
        ...state,
        orderValid: action.payload,
      };
    case SET_HAS_FORM_CHANGED:
      return {
        ...state,
        hasFormChanged: action.payload,
      };
    case SET_HAS_CONTENT_LOADED:
      return {
        ...state,
        hasContentLoaded: action.payload,
      };
    case SET_CURRENT_DIALOG:
      return {
        ...state,
        currentDialog: action.payload,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case SET_PROMPT_LOGIN:
      return {
        ...state,
        promptForLogin: action.payload,
      };
    case SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.payload,
      };
    default:
      return state;
  }
}
